<template>
    <div>
        <div v-html="form"></div>
    </div>
</template>
<script>
export default {
    data(){
        return{
        }
    },
    computed:{
        form(){
            return this.$route.query.form;
        }
    },
    created(){
        this.$loading({
            lock: true,
            text: "Loading",
        });
    },
    mounted(){
        this.$nextTick(() => {
            document.forms[0].submit()
        })
    }
}
</script>